import React, { createContext } from 'react'
import { BaseContextState, BaseContextProvider } from '../BaseContext'
import IIntegrationAdoptionStatus from '../../interfaces/IIntegrationAdoptionStatus'
import { loadStorage } from '../../services/storage'
import { STORAGE_KEY } from '../AuthContext'

// Integration API
import {
  ListAdoptionStatusRequest,
} from '../../services/integration/interfaces/ApiRequest'
import {
  setToken,
  partnerListAdoptionStatus
} from '../../services/integration'

interface IntegrationPartnerContextState extends BaseContextState {
  adoptionStatus: IIntegrationAdoptionStatus[] | null
}

export interface IntegrationPartnerContextData extends IntegrationPartnerContextState {
  resetErrors: Function,
  requestListAdoptionStatus: (args: ListAdoptionStatusRequest) => Promise<any>,
}

// Create context
const { Provider, Consumer } = createContext({} as IntegrationPartnerContextData)

// Export consumer
export const IntegrationPartnerConsumer = Consumer

export class IntegrationPartnerProvider extends BaseContextProvider {
  state: IntegrationPartnerContextState = {
    adoptionStatus: null
  }

  /**
   * Setup admin account session to integration API
   */
  componentDidMount() {
    const store = loadStorage(STORAGE_KEY)

    if (store) {
      setToken(store.accessToken)
    }
  }

  /**
   * Make api request for integration partner list adoption status
   * 
   * @param {PartnerListAdoptionStatusRequest} payload 
   */
   requestListAdoptionStatus = (payload: ListAdoptionStatusRequest) => {
    return new Promise(async (resolve, reject) => {
      this.setState({
        fetching: true,
        error: null
      }, async () => {
        let response = await partnerListAdoptionStatus(payload)
        this.processResponse(response, {
          mappings: {
            destination: 'adoptionStatus'
          }
        })
  
        if (this.state.success) {
          resolve(this.state.adoptionStatus)
        } else {
          reject(this.state.error)
        }
      })
    })
  }

  

  render() {
    return (
      <Provider
        value={{
          // States
          ...this.state,

          // Dispatches
          resetErrors: this.resetErrors,
          requestListAdoptionStatus: this.requestListAdoptionStatus,
        }}
      >
        {this.props.children}
      </Provider>
    )
  }
}
